export * from './layers';

export const CONFLICT_LAYER_IDS = ['pavingProjects', 'pavingMoratorium', 'cipProjects'] as const;

export type ConflictLayerId = (typeof CONFLICT_LAYER_IDS)[number];

export const PROJECT_CONFLICTS_DATASET_SLUG = 'projectConflicts'; // special-dataset slug on the conflict layer rows

export function isConflictLayer(layerId: string): layerId is ConflictLayerId {
  return (CONFLICT_LAYER_IDS as readonly string[]).includes(layerId);
}

export function isBoundaryLayer(layerId: string): boolean {
  return ['incorporatedPlaces', 'county', 'landUseTransportationDistrictBoundaries'].includes(layerId);
}

export function isCrossingsLayer(layerId: string): boolean {
  return ['landUseRailroads', 'transitRoutes', 'landUseRightOfWay'].includes(layerId);
}

/**
 * Conflict-layer start/end dates, whichever key the row happens to carry (start_date/end_date,
 * or the legacy conc_ / mora_ keys). The legacy fallback outlives the feature flag — rows written
 * before the cutover keep those keys until re-synced or backfilled, so PSCO-61 can't drop it on flag removal alone.
 */
export function getConflictDateStrings(properties?: Record<string, unknown> | null): {
  start?: string;
  end?: string;
} {
  const asDateString = (value: unknown) => (typeof value === 'string' && value ? value : undefined);

  return {
    start:
      asDateString(properties?.start_date) ??
      asDateString(properties?.conc_start) ??
      asDateString(properties?.mora_start),
    end: asDateString(properties?.end_date) ?? asDateString(properties?.conc_fin) ?? asDateString(properties?.mora_fin),
  };
}
